import { isMobile, loadEndless } from "../common/utils.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// reduced horizontal factor for lazy image loading in covers carousel
	if (isMobile()) {
		window.lazySizesConfig = window.lazySizesConfig || {};
		window.lazySizesConfig.hFac = 0.4;
	} else {
		loadEndless().then((endlessPaginate) => {
			if (!!document.querySelector(".endless_more") === false) {
				document.querySelector("#_show_more_multicol").classList.add("d-none");
			}
			document
				.querySelector("#_show_more_multicol")
				.addEventListener("click", (e) => {
					e.preventDefault();
					for (const el of document.querySelectorAll(".endless_more")) {
						el.click();
					}
				});
			endlessPaginate({
				onCompleted: () => {
					// desktop
					const articleColumn = document.querySelector("#_articles_column");
					const newsColumn = document.querySelector("#_news_column");
					if (articleColumn) {
						if (
							articleColumn.querySelector(".endless_more") === false ||
							newsColumn.querySelector(".endless_more") === false
						) {
							document
								.querySelector("#_show_more_multicol")
								.classList.add("d-none");
						}
						// Altezza colonne
						newsColumn.style.overflow = "visible";
						newsColumn.style.overflow = "hidden";
						newsColumn.style.height = getComputedStyle(articleColumn).height;
					}
				},
			});
		});
	}
});
